import React from "react";
import ProductInfo from "./ProductInfo";
import { MdOutlineFileDownload } from "react-icons/md";
import { useTranslation } from 'react-i18next';

/* ---------------------------------------------------------------------------- */

import {
  DownloadButton,
  DownloadList,
  ProductDescription,
  ProductDocument,
  ProductImage,
  ProductSection,
} from "./StyledComponents";

/* ----------------------------------------------------------------------------
 *          IMAGES
 * --------------------------------------------------------------------------- */

import TryggVardagBasicBild from "../../../../data/images/products/Trygg Vardag Basic/Basic_huvudbild.png";


/* ----------------------------------------------------------------------------
 *          DOWNLOAD FILES
 * --------------------------------------------------------------------------- */

import TryggVardagBasicManual from "../../../../data/downloads/Manual_trygg-vardag_BASIC_nya.pdf";
import TryggVardagBasicStartaUpp from "../../../../data/downloads/Starta_upp_trygg-vardag_basic_nya.pdf";
import TryggVardagRekond from "../../../../data/downloads/Trygg_vardag_rekonditionering_nya.pdf";

/* ----------------------------------------------------------------------------
 *          DOWNLOAD FILES - OLD
 * --------------------------------------------------------------------------- */

import TryggVardagBasicManual_gammal from "../../../../data/downloads/Manual-Trygg-Vardag-basic.pdf";
import TryggVardagBasicStartaUpp_gammal from "../../../../data/downloads/Starta-upp-Trygg-vardag-basic.pdf";


/* ============================================================================ */
/*          PORT | KOMM - function
/* ============================================================================ */


const TryggVardagBasic = () => {
  
  const { t } = useTranslation("products/tryggvardagbasic"); 

  return (
    <main className="product container">
      <ProductSection>
        <h1>{t('h1_tryggvardagbasic')}</h1>
        <ProductImage src={TryggVardagBasicBild} alt="" />

        <ProductDescription>
          <p>{t('p1_tryggvardagbasic')}</p>
          <p>{t('p2_tryggvardagbasic')}</p>
          <p>{t('p3_tryggvardagbasic')}</p>
        </ProductDescription>
    
        <ProductInfo titel={t('dokument_tryggvardagbasic')}>
          <ProductDocument>
            <ul>
              <p>{t('laddaner_tryggvardagbasic')}</p>

              <DownloadList>
                <DownloadButton>
                  <a href={TryggVardagBasicManual} download="manual-trygg-vardag-basic.pdf">
                    <span>Användarmanual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>                
                <DownloadButton>
                  <a href={TryggVardagBasicStartaUpp} download="Starta_upp_trygg_vardag-basic.pdf">
                    <span>Starta upp Manual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
                <DownloadButton>
                  <a href={TryggVardagRekond} download="manual_trygg_rekonditionering.pdf">
                    <span>Rekonditionersingsmanual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
              </DownloadList>
            </ul>
          </ProductDocument>
        </ProductInfo>

        <ProductInfo titel={t('dokument_tryggvardagbasic_gammal')}>
          <ProductDocument>
            <ul>
              <p>{t('laddaner_tryggvardagbasic')}</p>

              <DownloadList>
                <DownloadButton>
                  <a href={TryggVardagBasicManual_gammal} download="manual-trygg-vardag-basic-äldre-version.pdf">
                    <span>Användarmanual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>                
                <DownloadButton>
                  <a href={TryggVardagBasicStartaUpp_gammal} download="Starta_upp_trygg_vardag-basic-äldre -version.pdf">
                    <span>Starta upp Manual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
              </DownloadList>
            </ul>
          </ProductDocument>
        </ProductInfo>
        
      </ProductSection>
    </main>
  );
};

export default TryggVardagBasic;
